//@flow
import { call, put, takeLatest, takeEvery, all } from "redux-saga/effects";

import {
  ACTION_FEEDBACK_SUBMIT_REQUEST,
  ACTION_FEEDBACK_SUBMIT,
  ACTION_FEEDBACK_ERROR,
  ACTION_SEEN,
  ACTION_DONE,
  ACTION_DONE_REQUEST,
  ACTION_GET_NEW_ONE_REQUEST,
  ACTION_GET_NEW_ONE_ERROR,
  ACTION_GET_NEW_ONE_SUCCESS,
  ACTION_GET_ADMIN_REQUEST,
  ACTION_CANT_DO_REQUEST,
  ACTION_NEXT_CATEGORY_CHANGE,
} from "./constants";

import { fetchApi } from "../api";
import { modifyUser, userModifyRequesting } from "../user/actions";
import { setAction, changeActionState } from "./actions";

const endPoints = {
  doAction: "/v1/actions/see-action",
  chooseAction: "/v1/actions/next-action",
  submitFeedback: "/v1/actions/feedback",
  getNewAction: "/v1/actions/get-new-experience",
  getAdminAction: "/v1/actions/get-by-humanid",
  cantDoAction: "/v1/actions/cant-do-action",
  setNextCategory: "/v1/actions/set-next-category",
};
/*
const seeActionApi = (data: {
  userId: string,
  actionId: string,
  category: string,
  currentStreak: number,
  nextCategory: string,
  repetitionNumber: number,
  latest: string,
}) => {
  return fetchApi(endPoints.seeAction, data, "patch");
};*/
// la fonction n'est pas utilié et seeAction du endPoints n'existe pas

const doActionApi = (data: {
  userId: string;
  actionId: string;
  category: string;
  currentStreak: number;
  nextCategory: string;
  repetitionNumber: number;
  latest: string;
}) => {
  return fetchApi(endPoints.doAction, data, "patch");
};

const chooseActionApi = (data: { userId: string }) => {
  return fetchApi(endPoints.chooseAction, data, "post");
};

const submitFeedbackApi = (data: {
  userId: string;
  actionId: string;
  feedback: String;
  rating: Number;
}) => {
  return fetchApi(endPoints.submitFeedback, data, "post");
};

const getNewActionApi = (data: { userId: String; actionId: String }) => {
  return fetchApi(endPoints.getNewAction, data, "post");
};

const getAdminActionApi = (data: { humanId: String }) => {
  return fetchApi(endPoints.getAdminAction, data, "post");
};

const cantDoActionApi = (data: { userId: String }) => {
  return fetchApi(endPoints.cantDoAction, data, "post");
};

const setNextCategoryApi = (data: { userId: string; nextCategory: string }) => {
  return fetchApi(endPoints.setNextCategory, data, "post");
};

function* submitFeedbackFlow(action) {
  try {
    const response = yield call(submitFeedbackApi, action.payload);
    yield put({ type: ACTION_FEEDBACK_SUBMIT });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_FEEDBACK_ERROR });
  }
}

function* getNewActionFlow(action) {
  try {
    const newAction = yield call(getNewActionApi, action.payload);
    yield put(setAction(newAction));
    yield put({ type: ACTION_GET_NEW_ONE_SUCCESS });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_GET_NEW_ONE_ERROR, payload: error });
  }
}

function* getAdminActionFlow(action) {
  try {
    const newAction = yield call(getAdminActionApi, action.payload);
    yield put(setAction(newAction));
    yield put({ type: ACTION_GET_NEW_ONE_SUCCESS });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_GET_NEW_ONE_ERROR, payload: error });
  }
}

function* cantDoActionFlow(action) {
  try {
    const newAction = yield call(cantDoActionApi, action.payload);
    yield put(setAction(newAction));
    yield put({ type: ACTION_GET_NEW_ONE_SUCCESS });
    yield put(changeActionState({ actionState: "neutral" }));
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_GET_NEW_ONE_ERROR, payload: error });
  }
}

function* seeActionFlow(action) {
  try {
    console.log("ACTION");
    const { userId, actionSeenDate } = action.payload;
    console.log(userId);
    const user = yield put(
      userModifyRequesting({
        id: userId,
        payload: { actionState: "seen", actionSeenDate },
      }),
    );
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_FEEDBACK_ERROR });
  }
}

function* selectNextCategoryFlow(action) {
  try {
    const { nextCategory } = action.payload;
    const nextAction = yield call(setNextCategoryApi, action.payload);
    yield put(modifyUser({ nextCategory }));
    yield put(setAction(nextAction));
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_FEEDBACK_ERROR });
  }
}

function* doActionFlow(action) {
  try {
    const { feedback } = action.payload;
    yield put({ type: ACTION_DONE });
    const user = yield call(doActionApi, action.payload.action);
    yield put(modifyUser(user));
    yield put({ type: ACTION_DONE });
    const response = yield call(submitFeedbackApi, feedback);
    yield put(modifyUser(response));
    yield put({ type: ACTION_FEEDBACK_SUBMIT });
  } catch (error) {
    console.log(error);
    yield put({ type: ACTION_FEEDBACK_ERROR });
  }
}

function* trackWatcher() {
  yield all([
    takeLatest(ACTION_FEEDBACK_SUBMIT_REQUEST, submitFeedbackFlow),
    takeEvery(ACTION_SEEN, seeActionFlow),
    takeEvery(ACTION_DONE_REQUEST, doActionFlow),
    takeLatest(ACTION_GET_NEW_ONE_REQUEST, getNewActionFlow),
    takeLatest(ACTION_GET_ADMIN_REQUEST, getAdminActionFlow),
    takeLatest(ACTION_CANT_DO_REQUEST, cantDoActionFlow),
    takeLatest(ACTION_NEXT_CATEGORY_CHANGE, selectNextCategoryFlow),
  ]);
}

export default trackWatcher;
